import { Injectable } from '@angular/core';
import { AreaItemPack } from '../models/area-item-pack';
import { BookingOrderService } from './booking-order.service';
import { BookingProductStepService } from './booking-product-step.service';
import { GiftCardStepService } from '../../giftcard/services/giftcard-step.service';
import { ShopSettingsService } from '../../general/services/shop-settings.service';

@Injectable()
export class NavigationService {

  constructor(
    private shopSettingsService: ShopSettingsService,
    private bookingOrderService: BookingOrderService,
    private giftCardStepService: GiftCardStepService,
    private bookingProductStepService: BookingProductStepService,
  ) { }

  private get bookingAreaItemPack(): AreaItemPack[] {
    return this.bookingOrderService.allAreaItemPacks
      ?
      this.bookingOrderService.allAreaItemPacks.filter(item => !item.groupName && !item.showOnHomePage)
      :
      [];
  }

  get existGuestCardRefund(): boolean {
    return this.shopSettingsService.shopSettings.allowGuestCardRefund && this.shopSettingsService.isVUMode;
  }

  get existBooking(): boolean {
    return this.bookingAreaItemPack.length !== 0;
  }

  get existEvents(): boolean {
    return this.bookingOrderService.mainPageAreaItemPacks && this.bookingOrderService.mainPageAreaItemPacks.length !== 0;
  }

  get existGifts(): boolean {
    return this.giftCardStepService.existGiftCards;
  }

  get existProducts(): boolean {
    return this.bookingProductStepService.existProducts;
  }

  get existCardInformation(): boolean {
    return this.shopSettingsService.shopSettings.partnerCodePayment && this.shopSettingsService.isVUMode;
  }

  get onlyGifts(): boolean {
    return this.existGifts
      && !this.existBooking
      && !this.existEvents
      && !this.existCardInformation
      && !this.existGuestCardRefund
      && !this.existProducts;
  }

  get onlyProducts(): boolean {
    return this.existProducts
      && !this.existBooking
      && !this.existEvents
      && !this.existCardInformation
      && !this.existGuestCardRefund
      && !this.existGifts;
  }
}
